import * as React from "react";
const SvgFiRrFaceVomit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-vomit_svg__a)">
      <path
        fill="#062147"
        d="M18 22c-1.103 0-2-.897-2-2v-3.494c.157.111.294.212.383.281a.996.996 0 0 0 1.404-.17 1 1 0 0 0-.169-1.404C16.769 14.547 14.524 13 12.001 13s-4.769 1.548-5.617 2.213a1 1 0 0 0-.169 1.404 1 1 0 0 0 1.404.169c.088-.069.226-.17.383-.281v3.494c0 1.103-.897 2-2 2a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2zm-8.537 0A4 4 0 0 0 10 20v-4.582c.621-.242 1.306-.418 2-.418s1.379.177 2 .418V20c0 .728.195 1.411.537 2zM4 19.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 4 19.5m20 3a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 24 22.5m-2.744-2.863a1 1 0 0 1-1.407.134 1 1 0 0 1-.134-1.408A10 10 0 0 0 22.001 12c0-5.514-4.486-10-10-10S2 6.486 2 12c0 .927.126 1.844.376 2.728a1 1 0 0 1-1.924.544A12 12 0 0 1 0 12C0 5.383 5.383 0 12 0s12 5.383 12 12a12.02 12.02 0 0 1-2.744 7.637M17.554 7.832 15.802 9l1.752 1.168a1 1 0 0 1-1.11 1.664l-3-2a1 1 0 0 1 0-1.664l3-2a1 1 0 0 1 1.11 1.664M6.445 10.168 8.197 9 6.445 7.832a1 1 0 0 1 1.11-1.664l3 2a1 1 0 0 1 0 1.664l-3 2a1 1 0 1 1-1.11-1.664"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-vomit_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceVomit;
